import { IRootStore } from "..";
import { IAppPropsStore } from "./types";

export const getAppProps = ({ appPropsStore }: IRootStore): IAppPropsStore =>
  appPropsStore;
